import React from 'react'
import CsvDownloadLink from 'components/CsvDownloadLink'
import { domains } from 'lib/config'
import { csvTemplateHeaders } from './config'
import {
  TOOL_DESCRIPTION,
  LICENSEID_DESCRIPTION,
  NS_CUSTOMER,
  ADMIN_EMAILS,
} from './constants'
import { Instructions, ExampleImage, TemplateLinkWrapper } from './styles'

const BulkAssignInstructions: React.FC = () => {
  return (
    <>
      <h3>Tool Description</h3>
      <p>{TOOL_DESCRIPTION}</p>

      <TemplateLinkWrapper>
        <CsvDownloadLink
          autoClick={false}
          data={[{}]}
          filename="netsuite_assets_template.csv"
          headers={csvTemplateHeaders}
        >
          Download NetSuite Assets Template
        </CsvDownloadLink>
      </TemplateLinkWrapper>

      <h4>Fields Description</h4>
      <ul>
        <li>
          <b>License Id:</b> {LICENSEID_DESCRIPTION}
        </li>
        <li>
          <b>NsCustomerId:</b> {NS_CUSTOMER}
        </li>
        <li>
          <b>AdminEmails:</b> {ADMIN_EMAILS}
        </li>
      </ul>
      
      <Instructions>
        All uploaded spreadsheets should be formatted like this:
      </Instructions>
      <ExampleImage
        src={`${domains.CDN_DOMAIN}/assets/img/BulkAssign_netsuite_assets.png`}
      />
    </>
  )
}

export default BulkAssignInstructions

